import axios from "axios";
import BASE_URL from "../../config";

const getAuthHeader = () => {
  const tokenData = JSON.parse(localStorage.getItem("authUser") || "{}");
  return {
    Authorization: `Bearer ${tokenData.accessToken}`,
    'Content-Type': 'application/json'
  };
};

// Get price catalog items with pagination
export const getPriceCatalogItems = async (request) => {
  try {
    const response = await axios.post(`${BASE_URL}/api/PriceCatalog/get-items`, request, {
      headers: getAuthHeader(),
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching price catalog items:", error);
    throw error;
  }
};

// Get product stock details for price catalog
export const getProductStockDetails = async (productId, businessId = null, branchId = null) => {
  try {
    const params = new URLSearchParams();
    if (businessId) params.append('businessId', businessId);
    if (branchId) params.append('branchId', branchId);
    
    const response = await axios.get(
      `${BASE_URL}/api/PriceCatalog/product-stock/${productId}${params.toString() ? '?' + params.toString() : ''}`,
      {
        headers: getAuthHeader(),
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching product stock details:", error);
    throw error;
  }
};

// Update price for entity
export const updatePrice = async (request) => {
  try {
    const response = await axios.post(`${BASE_URL}/api/PriceCatalog/update-price`, request, {
      headers: getAuthHeader(),
    });
    return response.data;
  } catch (error) {
    console.error("Error updating price:", error);
    throw error;
  }
};

// Get package series details
export const getPackageSeriesDetails = async (seriesId) => {
  try {
    const response = await axios.get(`${BASE_URL}/api/PriceCatalog/package-series/${seriesId}`, {
      headers: getAuthHeader(),
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching package series details:", error);
    throw error;
  }
};

// Update package series installments
export const updatePackageSeriesInstallments = async (request) => {
  try {
    const response = await axios.post(`${BASE_URL}/api/PriceCatalog/update-package-series-installments`, request, {
      headers: getAuthHeader(),
    });
    return response.data;
  } catch (error) {
    console.error("Error updating package series installments:", error);
    throw error;
  }
};
